/**
 * Regional collection weather configuration
 * Maps collection slugs to their corresponding weather coordinates
 */
export const regionalWeatherConfig = {
  'minnesota/fargo-moorhead': {
    lat: 46.8772,
    lng: -96.7898,
    name: 'Fargo-Moorhead',
  },
  'minnesota/rochester': {
    lat: 44.0121,
    lng: -92.4802,
    name: 'Rochester',
  },
  'minnesota/duluth': {
    lat: 46.7867,
    lng: -92.1005,
    name: 'Duluth',
  },
};

/**
 * Check if a collection slug has regional weather
 * @param {string} slug - The collection canonical slug
 * @returns {{lat: number, lng: number, name: string}|null} Weather config object or null
 */
export const getRegionalWeatherConfig = (slug) => {
  return regionalWeatherConfig[slug] || null;
};
